import { render, staticRenderFns } from "./CreduTitulosTabela.vue?vue&type=template&id=5785ac7a&scoped=true"
import script from "./CreduTitulosTabela.vue?vue&type=script&lang=js"
export * from "./CreduTitulosTabela.vue?vue&type=script&lang=js"
import style0 from "./CreduTitulosTabela.vue?vue&type=style&index=0&id=5785ac7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785ac7a",
  null
  
)

export default component.exports